import { useNavigate } from "react-router-dom";
import TextField from "../../components/formcomponents/TextField";
import TextArea from "../../components/formcomponents/TextArea";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { uploadNewBlog ,uploadBlogImage} from "../../redux/actions/action";
import { FaFileUpload } from "react-icons/fa";
import { useSelector } from "react-redux";

const AddBlog = ({ onClose }) => {
  const [formData, setFormData] = useState({
    bloggerName: "",
    topicName: "",
    rolename: "",
    description: "",
    date: "",
    uploadPhoto:null,
    authorName: "",
    
  })
  const [errorMessage, setErrorMessage] = useState('')
  const [bloggerNameError, setBloggerNameError] = useState('')
  const [topicError, setTopicError] = useState('')
  const [roleError, setRoleError] = useState('')
  const [descriptionError, setDescriptionError] = useState('')
  const [dateError, setDateError] = useState('')
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showBlogForm, setShowBlogForm] = useState(false);
  const [uploadedFile,setUploadedFile] = useState(null);
  const [imageName,setImageName] = useState("" );

  const navigate = useNavigate()
  const dispatch = useDispatch();
   const blogs = useSelector((state) => state.uploadBlog.newBlog);

   console.log("upload blogs:",blogs)
   const topicName = formData.topicName 

  //  const authId = useSelector((state) => state.uploadBlogImage.byTopic[topicName]?.authId)

  const handleChange = (e) => {
    const { name, value ,files} = e.target

/// Handle file upload for 'upload_photo'
if (name === "upload_photo" && files?.length) {
  setUploadedFile(files[0]);
  setImageName(files[0].name);
 // console.log("Selected file:", files[0]);
  return;
}
    setFormData({
      ...formData, [e.target.name]: e.target.value,


    })
    
    if (name === "bloggerName") {
      setBloggerNameError("")
      validateBloggerName(value)
    } else if (name === "topicName") {
      setTopicError("")
      validateTopic(value)
    }
    else if (name === "rolename") {
      setRoleError("")
      validateRole(value)
    }
    
    else if (name === "date") {
      setDateError("")
      validateDate(value)
    }

  }
  

  const handleImageChange = (e) => {
    const imageFile = e.target.files[0];
    if (imageFile) {
      setUploadedFile(imageFile);
      setImageName(imageFile.name);
      setFormData((prev) => ({
        ...prev,
        uploadPhoto: imageFile,
      }));
    }
  };
    // };
  
  const blogData = {
    bloggerName: formData.bloggerName,
    topicName: formData.topicName,
    rolename: formData.rolename,
    description: formData.description,
    date: formData.date,
    authorName:formData.authorName,
    uploadPhoto:formData.uploadPhoto,
    blogId:formData.blogId,
    // authId:formData.authId,



  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

const blogresponse =      await dispatch(uploadNewBlog(blogData)); 
                                      




const newBlogId = blogresponse?.blogId
console.log("blog upload response:",blogresponse)
// console.log("extracted blog id",newBlogId)

      
      const fileData = uploadedFile ? new FormData() : null;
if (fileData) {
  fileData.append('image', uploadedFile);
  fileData.append('topicName', formData.topicName);
  fileData.append('authorName', formData.authorName);
  fileData.append('blog_id',newBlogId);  // ← add this
   fileData.append('auth_id',newBlogId)


                     const imageResponse = await dispatch(uploadBlogImage(fileData))
                            console.log("Image uploaded successfully:", imageResponse)
   


           onClose();
         }
         } catch (error) {
           console.error("Error submitting form:", error);
         }
    
    
    console.log(" Blog added, fetching blogs...");
    setShowSuccessPopup(true);
  
  }
  useEffect(() => {
    if (showSuccessPopup) {
      const timeoutId = setTimeout(() => {
        onClose();
        setShowSuccessPopup(false);
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
  }, [showSuccessPopup, onClose]);

  const validateBloggerName = (name) => {
    const regex = /^[A-Za-z\s]+$/;
    if (!regex.test(name)) {
      setErrorMessage('Blogger Name Must Contain Only Alphabets')
      return "Blogger Name Must Contain Only Alphabets";
    }
    else {
      setErrorMessage('')
      return ''
    }
  }

  const validateTopic = (name) => {
    const regex = /^[A-Za-z0-9\s!@#$%^&*()_+={}\[\]:;"'<>,.?/-]+$/;
    if (!regex.test(name)) {
      setErrorMessage('invalid characters in topic')
      return 'invalid characters in topic'
    }
    else {
      setErrorMessage('')
      return

    }
  }

  const validateDate = (selectedDate) => {
    const today = new Date()
    console.log(today)
    const formattedToday = today.toISOString().split("T")[0]
    console.log(formattedToday)

    if (selectedDate !== formattedToday) {

      setDateError("only today's date is allowed")
      return "only today's date is allowed"
    }
    else {
      setDateError("")
      return
    }

  }

  const validateRole = (name) => {
    const regex = /^[A-Za-z\s]+$/;
    if (!regex.test(name)) {
      setErrorMessage('role should contain only alphabets')
      return 'role should contain only alphabets'
    }
    else {
      setErrorMessage('')
      return
    }
  }



  return (
    <div className="relative bg-color mt-[400px] w-screen-full md:ml-[-500px] lg:ml-[300px] mr-16 xl:ml-[50px] rounded-3xl border-4 border-white popup-content grid justify-items-start">
      <div className="self-stretch flex flex-col bg-color items-start justify-start w-[500px] text-start text-xl text-black font-poppins rounded-3xl ">


 
    
    
      <form onSubmit={handleSubmit}       
          className="w-full mx-0 mt-4 m-0 md:mx-0 md:px-3 md:mt-8 lg:mx-0 lg:mt-5 lg:justify-center md:pt-4 lg:pr-24">

       {/* className="w-full bg-color p-6 rounded-xl shadow-lg">  */}

        
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6"> */}
               
                  {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-2 "> */}
                   
                  <div className="h-[150px] w-[150px] flex flex-col items-start justify-start pt-0 px-0 pb-4 box-border">
            <div className="self-stretch mx-2 flex-1 rounded-md bg-white overflow-hidden flex flex-col justify-center py-4 pr-0 pl-[10px] relative z-[1] border-[1px] border-solid border-gray-300">
              <label
                className="relative w-full h-[20px] bg-transparent items-center text-gray-700 text-left inline-block min-w-[70px] border-none outline-none font-poppins text-[14px] mt-[14px]" // Adjusted alignment with margin
              >
                Upload Photo
                <input
                  className="opacity-0 absolute top-0 left-0 w-full h-full cursor-pointer"
                  type="file"
                  onChange={handleImageChange}
                  name="upload_photo"
                />
              </label>
              <FaFileUpload className="w-[30px] h-[30px] absolute !m-[0] top-[10px] left-[calc(50%_-_15px)] overflow-hidden shrink-0 text-gray-400" />
            </div>
            {imageName && <p className="text-gray-600 text-xs mt-1">{imageName}</p>}
          
            
            
          {/* </div> */}
          
                    {/* </div> */}
          
                    
                   
          
                    
                  
          </div>

          <div className="flex flex-col mx-2 space-y-4 lg:space-y-0 pb-3 w-[400px]">
            <TextField
              label="Blogger Name*"
              name="bloggerName"
              type="text"
              value={formData.bloggerName}
              onChange={handleChange}
              placeholder="Enter Your First Name"
              required
              validate={validateBloggerName}
              error={bloggerNameError}
              className="w-full md:w-1/2 lg:w-1/4"
            />
          </div>
          
            <div >
            <label 
            className=" flex flex-col mx-2 space-y-4 lg:space-y-0 pb-3  font-bold text-white w-[400px]">
              Topic Title*</label>
            <select
              className="w-[400px] h-[45px] border border-gray-300 rounded-md px-3  mb-3" 
              // className="w-full md:w-1/2 lg:w-1/4 "
              name="topicName"
              value={formData.topicName}
              onChange={handleChange}
              required
            >
              <option value="">Select Topic</option>
              <option value="Artificial Intelligence(AI)">Artificial Intelligence(AI)</option>
              <option value="Internet Of Things(IOT)">Internet Of Things(IOT)</option>
              <option value="cloud computing">Cloud Computing</option>
              <option value="web applications">Web Applications</option>
              <option value="cyber security">Cybersecurity</option>
              <option value="Databases">Databases</option>
            </select>
          

          </div>
          
          <div className="flex flex-col mx-2 space-y-4 lg:space-y-0 pb-3 w-[400px]">
            <TextField
              label=" Author Name"
              name="authorName"
              type="text"
              value={formData.authorName}
              onChange={handleChange}
              placeholder="Enter Your First Name"
              // required
              // validate={validateBloggerName}
              // error={bloggerNameError}
              className="w-full md:w-1/2 lg:w-1/4"
            />
          </div>


          <div className="flex flex-col mx-2  space-y-4 lg:space-y-0 pb-3 w-[400px]">
            <TextField
              label="Date*"
              name="date"
              type="date"
              value={formData.date}
              onChange={handleChange}
              placeholder="Enter"
              required
              validate={validateDate}
              error={dateError}

              // className="w-full md:w-1/2 lg:w-1/4 "
              className="w-full h-[45px] border border-gray-300 rounded-md px-3  mb-3" 

            />
          </div>

          <div className="flex flex-col mx-2  space-y-4 lg:space-y-0 pb-3 w-[400px] ">
            <TextField
              label="Role*"
              name="rolename"
              type="text"
              value={formData.rolename}
              onChange={handleChange}
              placeholder="Enter"
              required
              validate={validateRole}
              error={roleError}
              className="w-full md:w-1/2 lg:w-1/4"
            />
          </div>
          <div className="relative flex flex-col mx-2 lg:flex-row space-y-4 lg:space-y-0 pb-3 w-[400px]">
            <TextArea
              label="Description*"
              name="description"
              type="text"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter "
              required
              error={descriptionError}
              width=" 400px"
            />
            <span
              className={`absolute bottom-10 right-4 text-xs transition-all duration-300
        ${formData.description.length > 0 ? "opacity-0" : "opacity-100"

                }

    `}
            >
              100 to 300 words</span>
          </div>
          <div className="flex justify-center mt-6 pb-5 ">
            <button type="submit"

              // onClick={onSave}
              className="bg-black text-white py-2 px-6 rounded-lg"
            >
              Save
            </button>
            <button
              onClick={onClose}

              className="bg-black text-white py-2 px-8 mx-6 rounded-lg"
            >
              Cancel
            </button>
          </div>
          {showSuccessPopup && (
            <div
              className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-800 bg-opacity-75 z-50"
              onClick={() => setShowSuccessPopup(false)}
            >
              <div className="bg-white rounded-lg p-8">
                <p className="text-black text-center">Successfully submitted.</p>

              </div>
            </div>
          )}
        </form>
        
    </div>

    
</div>

  )
}
export default AddBlog;